import { Component, Injector, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Sysai85PkgComponent } from './sysai85Pkg.component';
import { templateUrlConfigSys } from '../_service_sys';
import { MaterialModule } from 'jk-service';
import { JackBaseComponentModule } from 'jk-service';
import { JkaggridComponent } from 'jk-advcom';




@Component({
  selector: 'app-sysai85',
  standalone: true,
  providers: [],
  imports: [
    MaterialModule,
    JackBaseComponentModule,
    JkaggridComponent,
    //Sysai85DetailComponent,
  ],
  templateUrl: templateUrlConfigSys.sysai85,
  //template: ``,
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: [],
}) export class Sysai85Component extends Sysai85PkgComponent  {
  constructor() {
    super();
  }

  doParamTest(): void {
    // Parameter test logic here
    this.masterSrv.doParamTest();
    this.doUIRefresh(this.state, this.item);
  }
}
